import { useEffect, useState } from 'react';

import Grid from '@gds/Grid/Grid';
import { useAtomValue } from 'jotai';

import {
  initialLocationAggregationsState,
  locationAggregationsAtom,
} from 'Atoms/Search/LocationAggregationAtom/LocationAggregationAtom';

import { LocationAttrs, LocationCombinedParams } from 'Components/SearchWidget/Search.entity';
import { searchWidgetMessages } from 'Components/SearchWidget/SearchWidget.messages';
import { useLocationAggregations } from 'Hooks/UseLocationAggregations';

import styles from '../../Search.module.css';
import Area from '../Area/Area';
import Region from '../Region/Region';

type RegionAreWidgetProps = {
  locationAttrs: LocationAttrs;
  strings: Record<keyof typeof searchWidgetMessages, string>;
  tabletItemGridSpan: number;
  desktopItemGridSpan: number;
  locationCombinedParams?: LocationCombinedParams;
};

export const RegionAreaWidget = ({
  locationAttrs,
  strings,
  tabletItemGridSpan,
  desktopItemGridSpan,
  locationCombinedParams,
}: RegionAreWidgetProps) => {
  useLocationAggregations(locationAttrs);

  const [regionAreaCountInternal, setRegionAreasCountInternal] = useState(
    initialLocationAggregationsState,
  );
  const regionAreasCount = useAtomValue(locationAggregationsAtom);

  useEffect(() => {
    setRegionAreasCountInternal(regionAreasCount);
  }, [regionAreasCount]);

  return (
    <>
      <Grid.Col
        className={styles.searchCol}
        width={{ mobile: 12, tablet: tabletItemGridSpan, desktop: desktopItemGridSpan }}
      >
        <Region
          regionPlaceholder={strings.regionPlaceholder}
          areaPlaceholder={strings.areaPlaceholder}
          searchPlaceholder={strings.searchPlaceholder}
          noResultText={strings.noResultText}
          regionTitle={strings.regionTitle}
          state={regionAreaCountInternal}
          locationCombinedParams={locationCombinedParams}
        />
      </Grid.Col>
      <Grid.Col
        className={styles.searchCol}
        width={{ mobile: 12, tablet: tabletItemGridSpan, desktop: desktopItemGridSpan }}
      >
        <Area
          areaPlaceholder={strings.areaPlaceholder}
          searchPlaceholder={strings.searchPlaceholder}
          noResultText={strings.noResultText}
          areaTitle={strings.areaTitle}
          state={regionAreaCountInternal}
        />
      </Grid.Col>
    </>
  );
};
